window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.diplomaFramesBox = window.locales.am.diplomaFramesBox || {};window.locales.am.diplomaFramesBox = {...window.locales.am.diplomaFramesBox, ...{
    "heading": "የዲፕሎማ ክፈፎች",
    "content": "ስኬትዎን አሳዩ። የዲፕሎማ ክፈፎችን ይመልከቱ።",
    "buttonBrowseFrames": "ክፈፎች መመልከቻ"
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.diplomaFramesBox = window.locales.ar.diplomaFramesBox || {};window.locales.ar.diplomaFramesBox = {...window.locales.ar.diplomaFramesBox, ...{
    "heading": "إطارات الشهادة",
    "content": "أظهر إنجازك. تصفح إطارات الشهادة.",
    "buttonBrowseFrames": "تصفح الإطارات"
}
};window.locales.en = window.locales.en || {};window.locales.en.diplomaFramesBox = window.locales.en.diplomaFramesBox || {};window.locales.en.diplomaFramesBox = {...window.locales.en.diplomaFramesBox, ...{
    "heading": "Diploma Frames",
    "content": "Showcase your achievement. Browse diploma frames.",
    "buttonBrowseFrames": "Browse Frames"
}
};window.locales.es = window.locales.es || {};window.locales.es.diplomaFramesBox = window.locales.es.diplomaFramesBox || {};window.locales.es.diplomaFramesBox = {...window.locales.es.diplomaFramesBox, ...{
    "heading": "Marcos de Diploma",
    "content": "Muestra tu logro. Explora marcos de diploma.",
    "buttonBrowseFrames": "Explorar Marcos"
}
};window.locales.it = window.locales.it || {};window.locales.it.diplomaFramesBox = window.locales.it.diplomaFramesBox || {};window.locales.it.diplomaFramesBox = {...window.locales.it.diplomaFramesBox, ...{
    "heading": "Cornici per Diploma",
    "content": "Mostra il tuo risultato. Sfoglia le cornici per diploma.",
    "buttonBrowseFrames": "Sfoglia Cornici"
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.diplomaFramesBox = window.locales.zh.diplomaFramesBox || {};window.locales.zh.diplomaFramesBox = {...window.locales.zh.diplomaFramesBox, ...{
    "heading": "文凭相框",
    "content": "展示您的成就。浏览文凭相框。",
    "buttonBrowseFrames": "浏览相框"
}
};